import EventBus from "@/utils/EventBus.js";
import { updateCandidateOnboard } from "@/utils/apiFunctions";

const ONBOARDING_UPLOAD_FLOW_STORAGE_KEY =
	"landing_onboarding_upload_flow_active";

export default {
	data() {
		return {
			showOnboardingModal: false,
			showUploadResumeModal: false,
			onboardingResumeFlowActive: false,
			showUploadBackToOnboarding: false,
			fromOnboarding: false,
			showPersonalDetailsModal: false,
			selectedPersonalDetailsForm: {
				formID: "personalDetails",
			},
			personalDetailsModalType: "add",
			isInitialParserGateResolved: false,
			isCandidateHydrated: false,
			roadmapSkillToRedirect: null,
			isMobile: false,
		};
	},
	mounted() {
		this.checkScreen();

		window.addEventListener("resize", this.checkScreen);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.checkScreen);
	},
	methods: {
		checkScreen() {
			this.isMobile = window.innerWidth <= 1028;
		},
		setOnboardingModalVisible(shouldShow) {
			if (!shouldShow) {
				this.showOnboardingModal = false;
				return;
			}

			const gateReady =
				typeof this.isOnboardingGateReady === "function"
					? this.isOnboardingGateReady()
					: true;
			this.showOnboardingModal = gateReady;
		},
		setOnboardingUploadFlowState(state) {
			this.onboardingResumeFlowActive = !!state;
			try {
				if (state) {
					const stateValue = typeof state === "string" ? state : "1";
					localStorage.setItem(ONBOARDING_UPLOAD_FLOW_STORAGE_KEY, stateValue);
				} else {
					localStorage.removeItem(ONBOARDING_UPLOAD_FLOW_STORAGE_KEY);
				}
			} catch (error) {
				// Ignore storage access errors.
			}
		},
		openOnboardingStepOne() {
			this.showUploadResumeModal = false;
			this.showPersonalDetailsModal = false;
			this.showUploadBackToOnboarding = false;
			this.setOnboardingModalVisible(true);
		},
		restoreOnboardingFlowAfterReload() {
			let savedState = null;

			try {
				savedState = localStorage.getItem(ONBOARDING_UPLOAD_FLOW_STORAGE_KEY);
			} catch (error) {
				savedState = null;
			}

			if (!savedState) return;

			if (savedState === "upload") {
				this.onboardingResumeFlowActive = true;
				this.showOnboardingModal = false;
				this.showUploadBackToOnboarding = true;
				this.showUploadResumeModal = true;
			} else if (savedState === "personalDetails") {
				this.onboardingResumeFlowActive = true;
				this.showOnboardingModal = false;
				this.showUploadResumeModal = false;
				this.showUploadBackToOnboarding = false;
				this.personalDetailsModalType = "add";
				this.showPersonalDetailsModal = true;
			} else if (savedState === "1" || savedState === "onboarding") {
				this.setOnboardingUploadFlowState(false);
				this.openOnboardingStepOne();
			}
		},
		async ensureCandidateInfoForInitialGate() {
			if (this.isCandidateHydrated) {
				return;
			}

			const storedProfile =
				this.$store.state.candidateVUEX.primaryCandidateInfo;
			// Only trust the cached store if it contains database_demographics — the key field
			// written by a full primary-profile fetch.
			const hasFullProfileData =
				storedProfile &&
				storedProfile._id != null &&
				Object.prototype.hasOwnProperty.call(
					storedProfile,
					"database_demographics"
				);
			if (hasFullProfileData) {
				this.candidateData = storedProfile;
				try {
					await this.profileCompletion(storedProfile);
				} finally {
					this.isCandidateHydrated = true;
				}
				return;
			}

			// Fallback: Store was empty (e.g. App.vue fetch failed), make the call.
			this.isCandidateHydrated = false;
			await this.getCandidatePrimaryProfile();
			if (this.candidateData && this.candidateData._id != null) {
				try {
					await this.profileCompletion(this.candidateData);
				} finally {
					this.isCandidateHydrated = true;
				}
			}
		},
		isParserFlowBypassed(myCandInfo) {
			if (!myCandInfo) return false;

			const hasParserKey = Object.prototype.hasOwnProperty.call(
				myCandInfo,
				"parser"
			);
			if (!hasParserKey) return false;

			if (
				this.$route.query?.uuid ||
				this.$route.query?.type == "resumeClinic"
			) {
				return true;
			}

			if (
				(this.$route.query?.fromWebsite || this.$route.query?.fromTraining) &&
				myCandInfo._id != null
			) {
				return true;
			}
			return false;
		},
		closeOnboardingAndUploadModals() {
			this.showOnboardingModal = false;
			this.showUploadResumeModal = false;
			this.showUploadBackToOnboarding = false;
		},
		// openParserPersonalDetailsModal() {
		// 	this.setOnboardingUploadFlowState(false);
		// 	this.closeOnboardingAndUploadModals();

		// 	if (this.isMobile) {

		openParserPersonalDetailsModal() {
			// Guard against re-entrant calls. Prevents blank form
			if (this.showPersonalDetailsModal) {
				return;
			}
			this.setOnboardingUploadFlowState(false);
			this.closeOnboardingAndUploadModals();
			this.showUploadResume = false;
			if (this.isMobile) {
				this.$store.commit("userVUEX/setResumeClinic", true);
				const query = {
					formID: "personalDetails",
				};

				if (this.$route.query.type === "resumeClinic") {
					query.type = "resumeClinic";
				}
				if (this.$route.name !== "MobileForm") {
					this.$router.push({
						name: "MobileForm",
						query,
					});
				}
				return;
			}
			this.personalDetailsModalType = "add";
			this.selectedPersonalDetailsForm = {
				formID: "personalDetails",
			};
			this.showPersonalDetailsModal = true;
		},
		applyParserEntryDecision(
			myCandInfo,
			options = { allowOpenPersonalDetails: true }
		) {
			if (!myCandInfo || Object.keys(myCandInfo).length === 0) {
				return false;
			}

			if (this.isParserFlowBypassed(myCandInfo)) {
				this.closeOnboardingAndUploadModals();
				return true;
			}

			const hasDatabaseDemographics = Boolean(myCandInfo.database_demographics);
			if (hasDatabaseDemographics) {
				this.closeOnboardingAndUploadModals();
				return true;
			}

			const hasParserKey = Object.prototype.hasOwnProperty.call(
				myCandInfo,
				"parser"
			);
			if (!hasParserKey) {
				return false;
			}

			const hasParserData = Boolean(myCandInfo.parser);

			if (hasParserData && !hasDatabaseDemographics) {
				this.showOnboardingModal = false;
				if (options.allowOpenPersonalDetails) {
					this.openParserPersonalDetailsModal();
				}
				return true;
			}

			this.showPersonalDetailsModal = false;
			this.setOnboardingModalVisible(true);
			this.showUploadResumeModal = false;
			this.showUploadBackToOnboarding = false;
			return true;
		},
		async runInitialParserGate() {
			if (this.onboardingResumeFlowActive) {
				await this.ensureCandidateInfoForInitialGate();
				this.isInitialParserGateResolved = true;
				this.$emit("onboarding-check-complete");
				return;
			}
			try {
				await this.ensureCandidateInfoForInitialGate();
				this.applyParserEntryDecision(this.candidateInfo, {
					allowOpenPersonalDetails: true,
				});
			} finally {
				this.isInitialParserGateResolved = true;
				this.chkOnboardingRequirement(this.candidateInfo);
				this.$emit("onboarding-check-complete");
			}
		},
		parseRoadmapSkillsQuery(rawValue) {
			if (Array.isArray(rawValue)) {
				return rawValue
					.map((value) => String(value || "").trim())
					.filter(Boolean);
			}

			if (rawValue == null) return [];

			const rawString = String(rawValue).trim();
			if (!rawString) return [];

			const decodeSafely = (value) => {
				try {
					return decodeURIComponent(value);
				} catch (error) {
					return value;
				}
			};

			const candidates = [rawString, decodeSafely(rawString)];
			for (const candidate of candidates) {
				try {
					const parsed = JSON.parse(candidate);
					if (Array.isArray(parsed)) {
						return parsed
							.map((value) => String(value || "").trim())
							.filter(Boolean);
					}
				} catch (error) {
					// Fall through to the legacy string fallback below.
				}
			}

			return decodeSafely(rawString)
				.replace(/^\[/, "")
				.replace(/\]$/, "")
				.split(",")
				.map((value) => value.replace(/^\s*"|"\s*$/g, "").trim())
				.filter(Boolean);
		},
		parseRoadmapSkillEntry(rawEntry) {
			const entry = String(rawEntry || "").trim();
			if (!entry) {
				return {
					skillName: "",
				};
			}

			const match = entry.match(/^(.*?):\s*([1-4])\s*$/);
			if (!match) {
				return {
					skillName: entry,
				};
			}

			return {
				skillName: String(match[1] || "").trim(),
			};
		},
		extractRoadmapSkill() {
			const roadmapSkills = this.parseRoadmapSkillsQuery(
				this.$route?.query?.roadmapSkills
			);

			if (roadmapSkills.length === 0) {
				this.roadmapSkillToRedirect = null;
				return;
			}

			const firstSkillEntry = this.parseRoadmapSkillEntry(roadmapSkills[0]);
			if (firstSkillEntry.skillName) {
				this.roadmapSkillToRedirect = firstSkillEntry.skillName;
			}
		},
		handleOpenUploadResume() {
			this.fromOnboarding = true;
			this.setOnboardingUploadFlowState("upload");
			this.showOnboardingModal = false;
			this.showUploadBackToOnboarding = true;
			this.showUploadResumeModal = true;
		},
		handleUploadModalClosed() {
			this.showUploadResumeModal = false;

			if (!this.onboardingResumeFlowActive) return;

			this.setOnboardingUploadFlowState(false);
			this.openOnboardingStepOne();
		},
		handleBackToOnboardingFromUpload() {
			this.setOnboardingUploadFlowState(false);
			this.openOnboardingStepOne();
		},
		handleUploadParseComplete() {
			if (!this.onboardingResumeFlowActive) return;

			this.setOnboardingUploadFlowState("personalDetails");
		},
		async handleUploadCandidateDetail() {
			await this.getCandidatePrimaryProfile();
			this.showUploadResume = false
			if (this.candidateData && this.candidateData._id) {
				await this.profileCompletion(this.candidateData);
				this.isCandidateHydrated = true;
			}
			this.showUploadBackToOnboarding = false;

			if (this.onboardingResumeFlowActive) {
				this.showOnboardingModal = false;
				return;
			}

			this.chkOnboardingRequirement(this.candidateInfo);
		},
		handleUploadOpenFillForm() {
			this.setOnboardingUploadFlowState("personalDetails");
			// this.showUploadResumeModal = false;
			// this.showOnboardingModal = false;
			// this.showUploadBackToOnboarding = false;
			this.showUploadResume = false;
			if (this.isMobile) {
				const query = {
					formID: "personalDetails",
				};
				if (this.$route.query.type === "resumeClinic") {
					query.type = "resumeClinic";
				}
				this.$router.push({
					name: "MobileForm",
					query,
				});
				return;
			}

			this.personalDetailsModalType = "add";
			this.selectedPersonalDetailsForm = {
				formID: "personalDetails",
			};
			this.showPersonalDetailsModal = true;
		},
		handlePersonalDetailsModalClose() {
			this.showPersonalDetailsModal = false;

			if (!this.onboardingResumeFlowActive) return;

			this.setOnboardingUploadFlowState(false);
			this.openOnboardingStepOne();
		},
		getPostFormRedirectRoute() {
			// fromTraining: user came from the external training project.
			const fromTraining = this.$route?.query?.fromTraining;
			const returnUrl = this.$route?.query?.returnUrl;
			if (fromTraining && returnUrl) {
				return { external: true, url: decodeURIComponent(returnUrl) };
			}

			const byCompanyFlag = this.$route?.query?.bycompany;
			if (byCompanyFlag !== undefined) {
				const company = this.$route?.query?.company;
				const role = this.$route?.query?.role;
				return {
					name: "InterviewSkills",
					query: {
						bycompany: 1,
						company: company || "",
						role: role || "",
					},
				};
			}

			if (this.roadmapSkillToRedirect) {
				return {
					name: "InterviewSkills",
					query: {
						byskill: true,
						skill: this.roadmapSkillToRedirect,
						index: 0,
						rec: 0,
						byCompany: 0,
						roadmapSkills: this.$route?.query?.roadmapSkills,
					},
				};
			}

			return null;
		},
		async handlePersonalDetailsUpdated(data) {
			this.showPersonalDetailsModal = false;
			if (data && data.formID === "personalDetails") {
				const wasOnboardingUploadFlow = this.onboardingResumeFlowActive;

				await this.getCandidatePrimaryProfile();
				if (this.candidateData && this.candidateData._id) {
					await this.profileCompletion(this.candidateData);
					this.isCandidateHydrated = true;
				}
				// Emit globally so CandidateDashboard's existing updateData is called
				EventBus.$emit("update-data", { formID: "personalDetails" });

				if (wasOnboardingUploadFlow) {
					this.setOnboardingUploadFlowState(false);
					this.showOnboardingModal = false;
					this.showUploadBackToOnboarding = false;
				}

				const redirectRoute = this.getPostFormRedirectRoute();
				// Cross-domain redirect back to external training project.
				if (redirectRoute?.external) {
					window.location.href = redirectRoute.url;
					return;
				}
				if (redirectRoute) {
					await this.$router.push(redirectRoute);
					return;
				}

				if (wasOnboardingUploadFlow) {
					return;
				}

				this.chkOnboardingRequirement(this.candidateInfo);
			}
		},
		chkOnboardingRequirement(myCandInfo) {
			if (!this.isInitialParserGateResolved) {
				return;
			}

			if (!this.isCandidateHydrated) {
				this.setOnboardingModalVisible(false);
				return;
			}

			if (this.onboardingResumeFlowActive) {
				this.showOnboardingModal = false;
				return;
			}

			if (!myCandInfo || Object.keys(myCandInfo).length === 0) {
				this.showOnboardingModal = false;
				return;
			}

			if (
				this.applyParserEntryDecision(myCandInfo, {
					allowOpenPersonalDetails: true,
				})
			) {
				return;
			}

			const isExperiencedCandidate =
				String(myCandInfo.experienceLevel || "").toLowerCase() ===
				"intermediate";

			const propertiesToCheck = ["city", "profileSummary", "experienceLevel"];

			if (isExperiencedCandidate) {
				propertiesToCheck.push("designation", "totalYearsOfExp");
			}

			if (
				propertiesToCheck.some((property) => {
					return !myCandInfo[property];
				})
			) {
				if (myCandInfo._id === null) {
					this.setOnboardingModalVisible(false);
				} else {
					this.setOnboardingModalVisible(true);
				}
				return;
			}

			this.setOnboardingModalVisible(false);
		},
	},
};
